<template>
  <v-snackbar v-model="snackbar" shaped :color="barColor" :timeout="timeout">
    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" dark @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
export default {
  props: {
    timeout: {
      type: Number,
      default: 2000,
    },
    barColor: {
      type: String,
      default: "info",
    },
    message: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      snackbar: false,
    };
  },
  methods: {
    show() {
      this.snackbar = true;
    },
  },
};
</script>
